import { CareerId } from '@common/const/catalog/career';
import { TrainingAnswer, TrainingAnswersBlock } from '@common/model/client/training/types';
import { ITrainingApiProvider, ITrainingStorage } from '../lib';
import { Flow, FlowStep, FlowStepBlockStep, FlowStepType, GeneratorStep, generateFlow } from './flow';

export class TrainingService {
  private flow: Flow;
  private flowStep: GeneratorStep | null = null;
  constructor(
    private readonly apiProvider: ITrainingApiProvider,
    private readonly storage: ITrainingStorage,
  ) {}

  getStep() {
    return this.flowStep;
  }

  async startTraining(careerId: CareerId) {
    await this.apiProvider.start();
    const savedAnswers = this.storage.getAnswers();
    this.flow = generateFlow(careerId, savedAnswers);
    this.flowStep = this.flow.next();
  }

  async completeStep(answers?: TrainingAnswersBlock) {
    if (!this.flowStep) {
      return;
    }
    if (this.flowStep.done) {
      await this.finishTraining();
      return;
    }
    if (answers && this.#isBlockStep(this.flowStep.value)) {
      const block = this.flowStep.value.meta;
      this.storage.addStepAnswer(block.id, answers);
      this.flowStep = this.flow.next(this.storage.getBlockAnswers(block.id));
    } else {
      this.flowStep = this.flow.next();
    }
  }

  validateStep(answer: TrainingAnswersBlock): boolean {
    if (!this.flowStep || this.flowStep.done) {
      return true;
    }
    if (this.#isBlockStep(this.flowStep.value)) {
      return this.flowStep.value.validate(answer);
    }
    return true;
  }

  async finishTraining() {
    const answers = this.storage.getAnswers();
    await this.apiProvider.finish(answers);
  }

  #isBlockStep(step: FlowStep): step is FlowStepBlockStep {
    return step.type === FlowStepType.BlockStep;
  }
}
